export default "__VITE_ASSET__BQFYolem__"